var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"disabled":!_vm.alerta.placaValido && !_vm.alerta.placaCompleta,"variant":!_vm.ativar ? 'success' : ''},on:{"click":_vm.btnSalvarNovo}},[_vm._v("Salvar")])}
var staticRenderFns = []

export { render, staticRenderFns }